import {IBaseLookup} from "./Ibase.lookup";

export namespace OrderJustificationReason {

    export const lookupName: string = "OrderJustificationReason";

    export interface OrderJustificationReason {
        justificationReasonKey: number;
        justificationStatusKey: number;
        reasonDescription: string;
        active: string;
        lastUpdated: Date;
    }

    export interface OrderJustificationReasonDS extends IBaseLookup {
        orderJustificationReason: OrderJustificationReason[];
    }
}
